<template>
  <div>
    <Header />
    <div class="jumbotron">
      <div class="container">
        <p>
          Somos una familia que juntamos nuestros sueños, ideas, conocimientos,
          creaciones para darte lo mejor. Cada producto nuestro, cuenta una
          historia: un mate y la juntada con amigos, un cuchillo y el almuerzo
          en familia, un perchero y la compañía en la entrada de tu casa, un
          almohadón y la calidez del living y un cuadro para la persona que te
          gusta. Somos parte de las emociones que acompañan tu vida y esa
          responsabilidad nos enorgullece.
        </p>
        <p>
          El trabajo artesanal es nuestra esencia en una búsqueda constante por
          resignificarlo. Materiales de calidad, variedad de texturas, mixturas
          de colores que se combinan y dan nacimiento a diseños únicos,
          originales, exclusivos y hechos a tu medida. Los trabajos que
          realizamos son genuinos, coloridos y atractivos que explotan toda su
          esencia una vez que son elegidas por alguien.
        </p>
        <h5>CONTACTO</h5>
        <p>¡Dejanos tu consulta u opinión sobre Arte + & Tanuwa aquí!</p>

        <div class="contact">
          <img
            src="../assets/WhatsAppLogo.svg"
            alt="Image"
            height="30"
            width="30"
          />
          <span class="span">011 2521-1932</span>
        </div>
        <div class="contact">
          <img
            src="../assets/InstagramLogo.svg"
            alt="Image"
            height="30"
            width="30"
          />
          <span class="span">@arteymas.art</span>
        </div>
        <div class="contact">
          <img
            src="../assets/FacebookLogo.svg"
            alt="Image"
            height="30"
            width="30"
          />
          <span class="span">Arte+</span>
        </div>
        <div class="contact">
          <img
            src="../assets/MailLogo.svg"
            alt="Image"
            height="30"
            width="30"
          />
          <span class="span">arteymas@gmail.com</span>
        </div>
      </div>
    </div>

    <!-- <div class="container">
      <div class="row">
        <div class="col-md-8">
          <h2>Has been the industry's</h2>
          <p>Is simply dummy text of the printing and typesetting industry..</p>
          <form>
            <div class="form-group">
              <label>Nombre</label>
              <input name="name" class="form-control" />
            </div>
            <div class="form-group">
              <label>Mensaje</label>
              <textarea name="message" class="form-control"></textarea>
            </div>
            <div class="form-group">
              <button class="btn btn-primary" type="submit">Enviar</button>
            </div>
          </form>
        </div>
      </div>
    </div>-->
    <Footer />
  </div>
</template>


<script>
import Footer from "../components/Footer";
import Header from "../components/Header";
import user_detection from "../mixins/user_detection";

export default {
  mixins: [user_detection],
  name: "Contact",
  data() {
    return {};
  },
  mounted() {
    this.isUserAdmin();
  },
  computed: {},
  methods: {},
  components: {
    Footer,
    Header,
  },
};
</script>
<style scoped>
.jumbotron {
  padding: 1%;
  font-family: "Roboto";
  font-size: 16px;
}
.contact {
  margin-top: 30px;
  margin-bottom: 40px;
}
.span {
  margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/Contact.vue